export const LSKeys = {
  edsooAccessToken: 'edsooAccessToken',
  emailVerificationToken: 'emailVerificationToken',
};
